import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Checkerboard from './../Checkerboard';
import { getChessObjects, getClosureObjectsList } from './../../../redux/reducers/bookingSlice';
import { setPageData } from '../../../redux/reducers/pageSlice';
import { getUserTarif } from '../../../redux/reducers/tariffsSlice';

const CheckerboardWrap = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setPageData({
        pageTitle: 'Интерактивный календарь',
        pageDescription: 'Учет броней, оплат и доступности номеров',
      }),
    );

    return () => {
      dispatch(setPageData(null));
    };
  }, []);

  useEffect(() => {
    dispatch(getUserTarif());
    dispatch(getClosureObjectsList({}));
    dispatch(getChessObjects({}));
  }, []);

  return <Checkerboard />;
};
export default CheckerboardWrap;
